import { createContext, type ReactNode, useCallback, useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { Sidebar } from './Sidebar';

interface SidebarCtx {
  open: boolean;
  collapsed: boolean;
  toggle: () => void;
  close: () => void;
  toggleCollapsed: () => void;
}

const SidebarContext = createContext<SidebarCtx>({ open: false, collapsed: false, toggle: () => {}, close: () => {}, toggleCollapsed: () => {} });
export const useSidebar = () => useContext(SidebarContext);

interface Props {
  children: ReactNode;
}

export function AppShell({ children }: Props) {
  const [open, setOpen] = useState(() => window.matchMedia('(min-width: 1024px)').matches);
  const [collapsed, setCollapsed] = useState(false);
  const toggle = useCallback(() => setOpen((v) => !v), []);
  const close = useCallback(() => setOpen(false), []);
  const toggleCollapsed = useCallback(() => setCollapsed((v) => !v), []);

  return (
    <SidebarContext.Provider value={{ open, collapsed, toggle, close, toggleCollapsed }}>
      <div className="flex min-h-dvh">
        <a
          href="#main-content"
          className="brand-btn brand-btn-primary sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-50"
        >
          Skip to main content
        </a>

        <Sidebar />

        <div className="flex min-h-dvh flex-1 flex-col overflow-x-hidden">
          <main id="main-content" className="flex-1" tabIndex={-1}>
            <div className="mx-auto max-w-[1600px] pb-8">
              {children}
            </div>
          </main>
          <PageFooter />
        </div>
      </div>
    </SidebarContext.Provider>
  );
}

function PageFooter() {
  return (
    <footer className="brand-footer page-pad mt-auto">
      <div>STRICTLY PRIVATE &amp; CONFIDENTIAL · DIH HUB</div>
      <div className="flex items-center gap-3">
        <Link to="/terms" className="hover:text-petrol transition-colors duration-150">Terms</Link>
        <span aria-hidden="true">·</span>
        <Link to="/privacy" className="hover:text-petrol transition-colors duration-150">Privacy</Link>
        <span aria-hidden="true">·</span>
        <span>v1.0</span>
      </div>
    </footer>
  );
}
